const ERROR_MESSAGES = Object.freeze({
    NO_TICKET_DATA_PARAM: 'ERROR_NO_TICKET_DATA_PARAM',
    INVALID_TICKET_ENTER_RESPONSE: 'ERROR_INVALID_TICKET_ENTER_RESPONSE',
    INVALID_TICKET_DATA: 'ERROR_INVALID_TICKET_DATA',
    INVALID_REVEAL_GAME_ID: 'ERROR_INVALID_REVEAL_GAME_ID',
    CMS_NO_GAME_DATA: 'ERROR_CMS_NO_GAME_DATA',
    CMS_NO_ASSOCIATED_REVEAL_GAME: 'ERROR_CMS_NO_ASSOCIATED_REVEAL_GAME',
    CMS_NO_REVEAL_GAME_DATA: 'ERROR_CMS_NO_REVEAL_GAME_DATA',
    CMS_NO_CREDENTIALS: 'ERROR_CMS_NO_CREDENTIALS',
    CMS_NO_SITE_ASSETS: 'ERROR_CMS_NO_SITE_ASSETS',
    IGR_NO_AUTH_TOKEN: 'ERROR_IGR_NO_AUTH_TOKEN',
    IGR_AUTH_TOKEN_FAILURE: 'ERROR_IGR_AUTH_TOKEN_FAILURE',
    IGR_GAME_URL_NOT_RETURNED: 'ERROR_IGR_GAME_URL_NOT_RETURNED',
    GAME_FEED_REPORT_FAILED: 'ERROR_GAME_FEED_REPORT_FAILED',
    PLAY_PAGE_RELOADED: 'ERROR_PLAY_PAGE_RELOADED',
});

export default ERROR_MESSAGES;
